import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import NextApp from 'next/app';
export default (function (registry) {
  return function createApp() {
    function App(props) {
      var Component = props.Component,
          pageProps = props.pageProps;

      var getLayout = Component.getLayout || function (page) {
        return page;
      };

      var page = getLayout( /*#__PURE__*/React.createElement(Component, pageProps));
      var children = registry.app.render(props, page);
      return children;
    }

    App.propTypes = {
      Component: PropTypes.elementType,
      pageProps: PropTypes.object
    };

    App.getInitialProps = function (appContext) {
      var ctx = appContext.ctx;
      ctx.registry = registry;

      if (!process.browser && ctx.req) {
        // Intercept internal routes (like `/_next/static/...`) that would
        // render a high-fidelity error page (causing RBs, navs, etc. to be
        // fetched) and return a bare error page instead. We never expect
        // real users to navigate to such internal routes, so a fancy error
        // page isn't necessary, it just makes the server do more work.
        if (ctx.req.context.isInternalRoute && ctx.pathname === '/_error') {
          ctx.res.setHeader('Content-Type', 'text/plain');
          ctx.res.end(ctx.res.statusCode ? ctx.res.statusCode.toString() : '');
          return {};
        }
      }

      var getInitialProps = registry.app.enhanceInitialProps( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appContext) {
          var getExtensionProps, getAppProps, _yield$Promise$all, _yield$Promise$all2, extensionProps, appProps;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  getExtensionProps = registry.app.getInitialProps(appContext);
                  getAppProps = NextApp.getInitialProps(appContext);
                  _context.next = 4;
                  return Promise.all([getExtensionProps, getAppProps]);

                case 4:
                  _yield$Promise$all = _context.sent;
                  _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                  extensionProps = _yield$Promise$all2[0];
                  appProps = _yield$Promise$all2[1];
                  return _context.abrupt("return", _objectSpread(_objectSpread({}, extensionProps), appProps));

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      return getInitialProps(appContext);
    };

    return registry.app.enhance(App);
  };
});